import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';
import Fade from '@material-ui/core/Fade';
import Slide from '@material-ui/core/Slide';
import { AppTheme } from '../styles/AppTheme';
import { isMobile, isBrowser } from 'react-device-detect';
import { Helper } from '../common/helpers/Helper';
import { LoginCustomAdv } from './advertiser/LoginCustomAdv';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class LoginDialog extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Dialog
        TransitionComponent={isMobile ? Transition : Fade}
        open={this.props.openDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper),
          paper: css(Styles.paperDialog),
          root: isBrowser && css(Styles.dialogRoot)
        }}
        disableScrollLock={true}
        onClose={() => this.props.onClose()}>

        <div className={css(Styles.closeIconContainer)} onClick={() => this.props.onClose()}>
          <img
            alt={Helper.getString('closeLoginDialogAlt')}
            src={require('../assets/images/close-img.svg')}
            width='40' height='40'
            className={css(Styles.closeIcon)} />
        </div>

        <LoginCustomAdv
          showTerms={true}
          showOrgSignup={this.props.showOrgSignup}
          onClose={this.props.onClose}
          loginParams={this.props.loginParams}
          onSuccessLogin={this.props.onSuccessLogin}>
        </LoginCustomAdv>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  loginContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFFFF'
  },
  dialog: {
    minWidth: 500,
    borderRadius: '40px',//As Per Design
    maxWidth: 555,
    '@media(max-width: 768px)': {
      minWidth: '100%',
      margin: 5,
      borderRadius: '24px 24px 0px 0px',
    }
  },
  scrollPaper: {

    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',

      justifyContent: 'flex-start'
    }
  },
  dialogClosebuttonContainer: {
    paddingRight: 10,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: -40,
    zIndex: 1,
    cursor: 'pointer'
  },
  closeIconContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer',
    width: 15,
    position: 'absolute',
    top: 40,
    right: 40,
    '@media(max-width: 767px)': {
      top: 27,
      right: 27,
    }
  },
  closeIcon: {
    // width: '100%',
    '@media(max-width: 768px)': {
      width: 24,
      height: 24
    }
  },
  paperDialog: {
    // marginTop: AppTheme.toolbarHeight,
    '@media(max-width: 768px)': {
      width: '100%',
      bottom: 0,
      position: 'fixed',
      margin: 0,
      marginTop: 0,
    }
  },
  dialogRoot: {
    zIndex: 1000
  }

})


// WEBPACK FOOTER //
// ./src/components/LoginDialog.js